import {
  DELETE_INVESTMENT_HOLDING_OTHER_INCOME,
  GET_INVESTMENT_HOLDING_OTHER_INCOME,
  POST_INVESTMENT_HOLDING_OTHER_INCOME,
  PUT_INVESTMENT_HOLDING_OTHER_INCOME,
  COPY_INVESTMENT_HOLDING_OTHER_INCOME_FROM_PREVIOUS_YEARS,
} from "../constants/actionTypes";

const defaultState = {}
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_HOLDING_OTHER_INCOME:
        return {...state,...action.payload};
      case POST_INVESTMENT_HOLDING_OTHER_INCOME:
        return {...action.payload};
      case PUT_INVESTMENT_HOLDING_OTHER_INCOME:
        return {...state,...action.payload};
      case DELETE_INVESTMENT_HOLDING_OTHER_INCOME:
        data = [...state.otherIncomeArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,otherIncomeArr: [...newData]};
      case COPY_INVESTMENT_HOLDING_OTHER_INCOME_FROM_PREVIOUS_YEARS:
        return {
          ...state,
          otherIncomeArr: Array.isArray(action.payload) 
            ? [...action.payload]
            : state.otherIncomeArr,
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
